import type { GuideHealth } from '@/app/guide/flowStatus';
import type { StatusDotSpec } from '@/components/StatusDot';

/**
 * The guide status dot, shown on the Guides tab and beside a type's guide in the catalog. Green
 * means the app is serving a guide and it's current; amber (the colour the pending-changes badge
 * uses) means what's live has fallen behind its draft;
 * grey means nothing is published, so the space or type has no guide as far as anyone using the app
 * is concerned.
 */
export const GUIDE_DOTS: Record<GuideHealth, StatusDotSpec> = {
    live: { className: 'bg-green-600', title: 'A guide is live and in sync' },
    pending: { className: 'bg-amber-500', title: 'The live guide has unpublished changes' },
    none: { className: 'bg-slate-300', title: 'No guide is live' },
};
